<template>
  <Dialog
      :title="title"
      :show="showDialog"
      @onCancel="onCancel"
      @onConfirm="onConfirm"
      class="dialog-padding-container"
      :width="width"
  >
    <el-form :model="modelData" :rules="unusualInfoRules" label-width="150px" label-position="right">
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item prop="documentNumber" label="单据号：">
            <el-input disabled rows="1" v-model="modelData.documentNumber" type="input" />
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item prop="documentNumber" label="发生时间：">
            <el-date-picker
                v-model="modelData.operationTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label=" " class="jy-form-select flexbox">
            <el-checkbox v-model="modelData.isShow" label="显示在轨迹" size="large" />
          </el-form-item>
        </el-col>
        <el-col :span="24">

        </el-col>
        <el-col :span="24">
          <el-form-item prop="content" label="描述内容：">
            <el-input rows="3" v-model="modelData.content" type="textarea" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图片：">
            <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="99"
                listType="picture-card"
            ></uploadimgs>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </Dialog>
</template>

<script>
import utils from "@/assets/js/tool";
import uploadimgs from "@/components/uploadImgs/index.vue";

export default {
  name: "selectCustomers",
  components: {
    uploadimgs
  },
  props: {
    data: Array, //表单数据
    title: {
      // 标题
      type: String,
      default: "客服跟踪",
    },
    show: {
      // 是否展示弹窗
      type: Boolean,
      default: false,
    },
    width: {
      // 标题
      type: Number,
      default: 1180,
    },
    documentNumber: {
      type: String,
      default: "",
    },
    documentStatus: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDialog: false,
      modelData: {
        "content": "",
        "documentNumber": "",
        "documentStatus": "",
        "operationTime": "",
        "isShow": false,
      },
      fileNameLists: [],
      unusualInfoRules: {
        // 如果有验证规则可以在这里定义
      }
    };
  },
  watch: {
    show: {
      handler(newVal) {
        this.showDialog = newVal;
      },
      immediate: true
    },
    documentNumber: {
      handler(newVal) {
        this.modelData.documentNumber = newVal;
      },
      immediate: true
    },
    documentStatus: {
      handler(newVal) {
        this.modelData.documentStatus = newVal;
      },
      immediate: true
    }
  },
  methods: {
    changeFileList(array) {
      if (utils.jyCheckObjectType(array) == "Array") {
        this.fileNameLists = array;
      }
    },
    onCancel() {
      this.showDialog = false;
      this.$emit('onCancelCustomerService');
    },
    onConfirm() {
      let arr = [];
      this.fileNameLists.forEach(item => {
        if (item.status == 'success') {
          let obj = {
            fileId: item.name,
            fileName: item.name
          };
          arr.push(obj);
        }
      });

      // 处理是否显示在轨迹
      const params = {
        ...this.modelData,
        isShow: this.modelData.isShow ? 1 : 0,
        files: arr
      };

      API.addKfTrackRecord(params).then(res => {
        if (res.status == 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) == "Object") {
            this.$message({
              message: data.message,
              type: data.status,
            });
            this.$emit('onConfirmCustomerService', true);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-box{
  margin-top: 16px;
}
</style>
